
function isMobileDevice() {
  return window.innerWidth <= 768;
}

document.querySelectorAll('.product-gallery__media').forEach((media) => {
  media.addEventListener('click', function () {
 
    if (isMobileDevice()) {
      const zoomButton = document.querySelector('.product-gallery__zoom-button');
      if (zoomButton) {
        zoomButton.click(); // Trigger the zoom button click
      }
    }
  });
});